import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "styles";
import { TableRow, TableRowColumn, Table, TableBody } from "material-ui/Table";
import { renderApiList, renderApiDetails } from "../../utils";
export class UserRow extends Component {
  render() {
    const {
      email = "",
      apiList = [],
      company = {},
      endAt = "",
      name = "",
      startAt = "",
      subscription = "",
      surname = "",
    } = this.props.user;
    return (
      <TableRow>
        <TableRowColumn style={styles.tableRowBordered}>{email}</TableRowColumn>
        <TableRowColumn
          style={styles.tableRowBordered}
        >{`${name}, ${surname}`}</TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          {company.name}
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          {subscription}
        </TableRowColumn>
        <TableRowColumn
          style={{ ...styles.tableRowBordered, verticalAlign: "top" }}
        >
          {renderApiList(apiList)}
        </TableRowColumn>
        <TableRowColumn
          style={{ ...styles.tableRowColumnBigCSS, padding: "0px" }}
        >
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn style={styles.nestedRowColumn}>
                  {renderApiDetails(apiList, "today", 'perDayLimit')}
                </TableRowColumn>
                <TableRowColumn
                  style={{
                    ...styles.nestedRowColumn,
                    borderLeft: "1px solid rgb(224, 224, 224)",
                    borderRight: "1px solid rgb(224, 224, 224)",
                  }}
                >
                  {renderApiDetails(apiList, "dayBefore", 'perDayLimit')}
                </TableRowColumn>
                <TableRowColumn style={styles.nestedRowColumn}>
                  {renderApiDetails(apiList, "thisMonth", 'perMonthLimit')}
                </TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
        </TableRowColumn>
        <TableRowColumn
          style={{
            ...styles.tableRowBordered,
            padding: "15px",
            height: "100%",
            verticalAlign: "top",
            maxWidth: "200px",
          }}
        >
          {renderApiDetails(apiList, "thisMonth", "perMonthLimit")}
        </TableRowColumn>
      </TableRow>
    );
  }
}

export default connect(({ companyUser }) => ({
  user: companyUser.data,
}))(UserRow);



// WEBPACK FOOTER //
// ./app/components/Integrators/User/Rows/UserRow.jsx